<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12">
        <v-card elevation="5" class="pa-2 text-center">
          <p class="px-10 py-5">
            Missed a delivery? Have your item redelivered to an address, post office,
            or Easipik parcel locker.
          </p>
          <v-btn
            color="primary"
            @click="startRedeliveryRequest()"
            class="px-10 py-5 mb-5"
          >
            Start Redelivery Request
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Intro",
  data: () => ({}),
  computed: {},
  methods: {
    startRedeliveryRequest: function () {
      this.$store.dispatch("missedDelivery/startRedeliveryRequest");
    },
  },
};
</script>
